<template>
  <div
    class="shop-by-campaign-container"
    data-analytics-id="homepage-container"
    data-analytics-label="Shop By Campaign"
  >
    <ShopByCampaign :title="shopByCampaignTitle">
      <div
        v-for="(shopByCampaignImage, index) in shopByCampaignImages"
        :key="shopByCampaignImage.id"
        class="column is-2-desktop is-2-tablet is-4-mobile"
      >
        <SmartLink
          :native="false"
          :to="shopByCampaignImage.url"
          class="shop-by-campaign-image-link"
          data-analytics-id="homepage-link"
          data-analytics-action="shop-by-campaign"
          :data-analytics-label="shopByCampaignImage.url"
          :data-analytics-record-id="shopByCampaignImage.id"
          @click="
            trackClicked(
              index,
              shopByCampaignImage.title || shopByCampaignImage.url
            )
          "
        >
          <nuxt-img
            loading="lazy"
            :src="shopByCampaignImage.imageUrl"
            :alt="
              shopByCampaignImage.title || `${shopByCampaignTitle} ${index}`
            "
            class="shop-by-campaign-image"
          />
          <span
            v-if="shopByCampaignImage.title"
            class="shop-by-campaign-image-title"
          >
            {{ shopByCampaignImage.title }}
          </span>
        </SmartLink>
      </div>
    </ShopByCampaign>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import snakeCase from 'lodash/snakeCase'
import ShopByCampaign from '@sephora-asia/core-shop-by-campaign/ShopByCampaign.vue'
import impressionTracking from '@sephora-asia/common-ui/mixins/impressionTracking.js'

export default {
  name: 'ShopByCampaignContainer',

  components: {
    ShopByCampaign
  },

  mixins: [impressionTracking],

  computed: {
    ...mapGetters({
      shopByCampaignTitle: 'shopByCampaign/title',
      shopByCampaignImages: 'shopByCampaign/images'
    })
  },

  methods: {
    trackClicked(index, title) {
      const attributeName = snakeCase(this.shopByCampaignTitle)
      const params = {}
      params[`${attributeName}_position`] = index + 1
      params[`${attributeName}_name`] = title

      this.$analytics.trackEvent(`homepage_click_${attributeName}`, {
        params
      })
    },
    trackImpression() {
      this.$analytics.trackEvent(
        `homepage_impression_${snakeCase(this.shopByCampaignTitle)}`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-by-campaign-container {
  margin-bottom: 24px;
  width: 100%;

  @include mobile {
    margin-bottom: 24px;
    margin-top: 8px;
  }

  .shop-by-campaign-image-link {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    @include desktop {
      border: 1px solid $grey-light;
      margin: 5px;
    }
  }

  .shop-by-campaign-image-title {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    word-wrap: break-word;

    @include mobile {
      padding-top: 10px;
    }
  }

  .shop-by-campaign-image {
    width: 100%;
  }
}
</style>
